var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('account-statements',{attrs:{"creancierID":_vm.id,"hiddenFilter":'creancierID = ' + _vm.id,"nobreadcrumb":"","nofacets":"","nosearch":"","directLoad":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }